"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ResourceHelper = {
  getName: function getName(resource) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        anyResourceName = _ref.anyResourceName,
        ownerResourceName = _ref.ownerResourceName;

    if (resource === null) return anyResourceName;
    return resource.role === 'owner' && (resource.name === null || resource.name === '') ? ownerResourceName : resource.name;
  }
};
var _default = ResourceHelper;
exports["default"] = _default;